<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- SPF白名单IP -->
            <el-tab-pane label="">
                <span slot="label">{{ $t("logs.spf7") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="save2()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.spf1") }}</el-button>
                        <el-button @click="daoru()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.spf2") }}</el-button>
                        <el-button @click="daochu()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.spf3") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                            </el-table-column>
                            <el-table-column prop="IPADDR" :label="$t('logs.network1_a5')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick1(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_cert_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_cert_domain"><span class="span_pad"></span> {{$t('logs.spf1')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.Policy_unit_ip1") }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="ipaddr" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save21()" :disabled="$root.jurisdiction.only_query == 0">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_save2()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu" ></div>
                    <div class="pop-up" v-show="tanchu_to_ip" v-drag="{ handle: '.pop_up_text_import_br' }"
            >
              <div class="pop_up_text  pop_up_text_import_br">
                <span style="padding:0 14px"></span>{{ $t("logs.spf2") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading">
                            <div class="find1">

                                <div class="block block1">
                                    <input type="file" @change="inputFileChange" id="iupfile_ip" ref="clearFile" accept=".txt" />
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" size="mini" @click="save022">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="save23()">{{$t('tan.cancel')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_to_ip"></div>
                </div>
            </el-tab-pane>
            <!-- SPF白名单账号 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.spf8") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="show_wemail()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.spf4") }}</el-button>
                        <el-button @click="daoru_wemail()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.spf5") }}</el-button>
                        <el-button @click="daochu_wemail()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.spf6") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList2" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')">
                            </el-table-column>
                            <el-table-column prop="DNOREMAIL" :label="$t('logs.notify7')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template slot-scope="scope">
                                    <!-- 删除 -->

                                    <el-button @click="handleClick2(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">
                                        {{ $t("table1.delete") }}
                                    </el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="wlemail" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.spf4')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.notify7") }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="dnoremail" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_wemail()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_wemail()">{{$t('logs.save_b')}}</el-button>

                        </el-row>
                    </div>
                    <div class="gray" v-show="wlemail"></div>
                    <div class="pop-up" v-show="tanchu_to_email" v-drag="{ handle: '.pop_up_text_import_iup' }"
            >
              <div class="pop_up_text  pop_up_text_import_iup">
                <span style="padding:0 14px"></span>{{ $t("logs.spf5") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading">
                            <div class="find1">

                                <div class="block block1">
                                    <input type="file" @change="inputFileChange1" id="iupfile1" ref="clearFile" accept=".txt" />
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" size="mini" @click="save_w_email">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="off_w_email()">{{$t('tan.cancel')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_to_email"></div>
                </div>
            </el-tab-pane>

        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            loading:false,
            tanchu_to_email: false,
            wlemail: false,
            tanchu_to_ip: false,
            dnoremail: '',
            ipaddr: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            fileList2: [],
            radio: [],
            files: '',
            files1: '',
        };
    },
    mounted() {
        this.getFileList1()
        this.getFileList2()
    },
    methods: {
        // SPF白名单账号导出
        daochu_wemail() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_spfwlemail";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&sid=${sid}`);
        },
        inputFileChange1(e) {

            this.files1 = e.target.files[0];
            // console.log(this.files);
        },
        // 白名单增加
        save_w_email() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let iupfile = this.files1;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files1.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
                this.loading=true
                this.tanchu = false;
                let fd = new FormData();
                fd.append("iupfile1", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", " upload_spfwlemail");
                fd.append("sid", sid);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/aspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    console.log(res);
                    this.loading=false
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.loading = false;

                        this.getFileList2();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files1 = ''
                        // console.log(this.files)
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del3')}`,
                        });
                        this.tanchu_to_email = false;
                    }
                    
                });
            }
        },

        // 内容过滤删除
        handleClick2(index, scope) {
            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let dnoremail = scope.DNOREMAIL;

                    this.$axios
                        .get("/api/adm/cgi/aspam.cgi", {
                            params: {
                                __mode: "del_spfwlemail",
                                sid: sid,

                                dnoremail: dnoremail,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                // this.loading = false;
                                this.getFileList2();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        save_wemail() {
            this.$save_hint_test();
            this.$disable_hint_test();

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let dnoremail = this.dnoremail;
            let str = this.$qs.stringify({
                __mode: "save_spfwlemail",
                sid: sid,
                dnoremail: dnoremail,
            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.loading = false;
                        this.wlemail = false;

                        this.getFileList2();
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                    }
                })
               
            this.ipaddr = "";
        },
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "list_spfwlemail",
                        sid: sid,

                    },
                })
                .then((res) => {
                    // console.log(res);

                     if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList2 = res.data.ret.datalist;
                    }
                });
        },
        // spf白名单ip导出
        daochu() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_spfipwl";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&sid=${sid}`);
        },
        inputFileChange(e) {

            this.files = e.target.files[0];
            // console.log(this.files);
        },
        // 白名单增加
        save022() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
                this.loading=true
                this.tanchu = false;
                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_spfipwl");
                fd.append("sid", sid);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/aspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    console.log(res);
                        this.loading = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                      
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.getFileList1();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        // console.log(this.files)
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del3')}`,
                        });
                        this.tanchu_to_ip = false;
                    }
                   
                });
            }
        },
        // 导入ip白名单
        daoru() {
            this.tanchu_to_ip = true
             document.getElementById("iupfile_ip").value=""
        },
        // 导入ip白名单
        daoru_wemail() {
            this.tanchu_to_email = true
             document.getElementById("iupfile1").value=""

        },
        save23() {
            this.tanchu_to_ip = false;
        },
        off_w_email() {
            this.tanchu_to_email = false;
        },

        // 内容过滤删除
        handleClick1(index, scope) {
            // console.log(index, scope)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    let wlip = scope.ORGIP;

                    this.$axios
                        .get("/api/adm/cgi/aspam.cgi", {
                            params: {
                                __mode: "del_spfipwl",
                                sid: sid,

                                wlip: wlip,
                            },
                        })
                        .then((res) => {
                            // console.log(res);

                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                                // this.getFileList();
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                // this.loading = false;
                                this.getFileList1();
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "list_spfipwl",
                        sid: sid,

                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
             this.loading = false;
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList = res.data.ret.datalist;
                    }
                });
        },
        save21() {
            this.$save_hint_test();
            this.$disable_hint_test();

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let ipaddr = this.ipaddr;
            let str = this.$qs.stringify({
                __mode: "save_spfipwl",
                sid: sid,
                ipaddr: ipaddr,
            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {

                        this.loading = false;
                        this.tanchu = false;

                        this.getFileList1();
                        this.$message({
                            type: "success",
                            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
                        });
                    }
                })
               
            this.ipaddr = "";
        },
        // 显示
        save2: function () {
            this.tanchu = true;
            this.ipaddr = ''

        },
        off_save2() {
            this.tanchu = false;

        },
        // 显示
        show_wemail: function () {
            this.wlemail = true;
            this.dnoremail = ''

        },
        off_wemail() {
            this.wlemail = false;

        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

// 时间
.time {
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
    background: #f1f1f1;
    margin: 10px 0;
}

.time1 {
    display: flex;
    align-items: center;
    padding: 2px 0 2px 14px;
    font-size: 14px;
}

// 手动设置
.time-text1 {
    padding-left: 20px;
}

// 后台管理控制
.back {
    display: flex;
    font-size: 14px;
    line-height: 30px;
    align-items: center;
    padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
    margin: 0 10px;
}

.backText {
    text-align: right;
}

.backText1 {
    color: #999;
    font-size: 12px;
}

.back .el-input {
    width: 20%;
    padding: 0;
}

.time2 {
    display: flex;
    margin-left: 190px;
    margin-top: 10px;
}

.time2 .el-button {
    padding: 8px 24px;
    // margin: 10px ;
}

// License
.time3 {
    display: flex;
    align-items: center;
    // margin-left: 150px;
    font-size: 14px;
    padding: 4px 10px;
}

// selece
.selece1 {
    width: 130px;
}

// input 框
.back1 .input1 {
    width: 100px;
    margin: 0 10px;
}

// 单选框
.check1 {
    margin: 0 10px;
}

.backText2 {
    margin-left: 40px;
}

.backText3 {
    margin-left: 30px;
}

.back1 .input5-1 {
    width: 100px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
</style>
